<template>
  <div
    v-if="isEllipsis && text.length > 17"
    v-tooltip="{ content: text, placement: 'top-center', classes: 'tight' }"
    class="vcv-tag is-ellipsis"
    :class="{ disabled, 'is-removable': isRemovable }"
  >
    <span>{{ text }}</span>

    <i v-if="isRemovable" class="icon icon-close vcv-tag__remove" @click="$emit('remove')"></i>
  </div>

  <div v-else class="vcv-tag" :class="{ disabled, 'is-removable': isRemovable, 'is-dashed': isDashed }">
    <span v-html="text"></span>

    <i v-if="isRemovable" class="icon icon-close vcv-tag__remove" @click="$emit('remove')"></i>
  </div>
</template>

<script>
export default {
  name: 'VcvTag',

  props: {
    text: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    },

    isRemovable: {
      type: Boolean,
      default: false
    },

    isEllipsis: {
      type: Boolean,
      default: false
    },

    isDashed: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcv-tag {
  @include mixin-text-tag;
  padding: 4px 5px;
  border: 1px solid $grey-light;
  background: $white;
  border-radius: 3px;
  height: 23px;
  position: relative;
  margin-right: 6px;
  white-space: nowrap;
  max-width: 100%;
  display: inline-flex;
  align-items: center;
  cursor: default;
  overflow: hidden;
  color: $main-dark;
  text-overflow: ellipsis;
  pointer-events: auto;
  transition: opacity 0.5s;

  &__remove {
    font-size: 12px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 23px;
    color: $grey;
    margin-left: 5px;
    cursor: pointer;
    transition: background 0.3s, color 0.3s;

    &:hover {
      background: $red-lighter;
      color: $white;
      transition: background 0.3s, color 0.3s;
    }
  }

  &.is-ellipsis {
    max-width: 160px;
  }

  &.is-removable {
    padding-right: 0;
    border-radius: 4px;
  }

  &.is-dashed {
    border: 1px dashed $grey-light;
    color: $grey;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: $main-dark;
      transition: color 0.3s;
    }
  }

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
    transition: opacity 0.5s;
  }
}
</style>
